import { Box, Checkbox, Flex, Icons, Loading, Page, SearchBar, Section, Typography } from 'components';
import { useAuth } from 'features/auth';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MessageIcon, MessageInbox } from './components';
import MessageCard, { MessageItemProps } from './components/messageCard/MessageCard';
import { answerItem } from './components/messageInbox/MessageInbox';

const SearchWrapper = styled((props) => <Flex {...props} />)`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  background: ${({ theme }) => theme.colors.gray_200};
  align-items: center;
`;

const IconMessagePrimary = styled(Icons)`
  width: 50px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

const IconPrimary = styled(Icons)`
  width: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

const Icon = styled(Icons)`
  width: 20px;
  color: ${({ theme }) => theme.colors.gray_500};
`;

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  left: 0;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    z-index: 1000;
  }

  &::before {
    content: '';
    display: block;

    border-top: 2px solid ${({ theme }) => theme.colors.white25};
    border-right: 2px solid ${({ theme }) => theme.colors.white25};
    position: absolute;

    right: 0px;
    z-index: 1;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.mobile} {
      top: 1px;
      left: -25px;

      &::after {
        width: 14px;
        height: 14px;
      }

      &::before {
        top: -30px;
        width: 150px;
        height: 230px;
      }
    }

    ${mediaQueries.tablet} {
      left: -30px;

      &::after {
        width: 14px;
        height: 14px;
        top: 3px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 100px;
        height: 150px;
      }
    }

    ${mediaQueries.desktop} {
      top: 4px;
      left: -40px;

      &::after {
        width: 17px;
        height: 17px;
        top: 0px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 150px;
        height: 280px;
      }
    }
  `;
  }}
`;

const MessagesView = () => {
  const [loading, setLoading] = useState(false);

  const [searchText, setSearchText] = useState('');
  const [enabledFilter, setEnabledFilter] = useState(0);
  const { fullName } = useAuth();
  const [messageSelected, setMessageSelected] = useState<string | null>(null);
  const currentPage = 1;
  const totalPages = 1;

  const [tab, setTab] = useState('all');

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  });

  const [messages, setMessages] = useState<MessageItemProps[]>([
    {
      uuid: '2',
      title: 'Dúvida sobre questão da avaliação',
      text: '<p>Olá professor, tudo bem? </p><p>Fiquei com uma dúvida na última atividade sobre legislação, poderia me ajudar? </p><p>Estou um pouco confusa sobre a distinção entre imposto e taxa. Na atividade, foi mencionado que ambos são espécies de tributos, mas não consegui entender claramente as diferenças principais entre eles, especialmente no contexto de aplicação prática. Poderia explicar de forma mais detalhada como cada um funciona e em quais situações são aplicados? </p><p>Agradeço desde já pela ajuda!  </p><p>Atenciosamente,</p><p> M. Carolina</p>',
      sender: fullName,
      subjects: 'Estatística Aplicada I',
      status: 1,
      isDelete: false,
      isAchive: false,
      isResponded: false,
      date: '2024-12-02T21:30:00+00:00',
      answer: {
        sender: 'Prof. Carlos Henrique',
        date: '2024-12-03T21:30:00+00:00',
        text: '<p>Olá,</p><p>não se preocupe, vou explicar isso certinho na próxima aula.</p><p>Atenciosamente,  </p><p>C. Henrique</p>',
      },
      type: 'all',
    },
    {
      uuid: '3',
      title: 'Dúvida sobre questão da avaliação',
      text: '<p>Olá professor, tudo bem? </p><p>Fiquei com uma dúvida na última atividade sobre legislação, poderia me ajudar? </p><p>Estou um pouco confusa sobre a distinção entre imposto e taxa. Na atividade, foi mencionado que ambos são espécies de tributos, mas não consegui entender claramente as diferenças principais entre eles, especialmente no contexto de aplicação prática. Poderia explicar de forma mais detalhada como cada um funciona e em quais situações são aplicados? </p><p>Agradeço desde já pela ajuda!  </p><p>Atenciosamente,</p><p> M. Carolina</p>',
      sender: fullName,
      subjects: 'Estatística Aplicada I',
      status: 0,
      isDelete: false,
      isAchive: false,
      isResponded: false,
      date: '2024-12-02T21:30:00+00:00',
      answer: {
        sender: 'Prof. Carlos Henrique',
        date: '2024-12-03T21:30:00+00:00',
        text: '<p>Olá,</p><p>não se preocupe, vou explicar isso certinho na próxima aula.</p><p>Atenciosamente,  </p><p>C. Henrique</p>',
      },
      type: 'deleted',
    },
  ]);

  function onSearchSubmit() {}

  return (
    <Page title="Minhas Mensagens">
      {loading && <Loading alpha />}

      <Flex flexGrow={0} bg="navbarBg">
        <Section flexDirection={{ m: 'column', d: 'row' }} justifyContent="space-between">
          <Flex flexGrow={0} flexDirection="column" pt={{ m: 40, d: 40 }} pb={{ m: 60, d: 100 }}>
            <Box position="relative">
              <SquareLines />
              <Typography type="type5" color="white" fontWeight="bold" upper>
                Minhas
              </Typography>
            </Box>

            <Typography type="type11" color="white" fontWeight="bold" mt={2}>
              Mensagens
            </Typography>
          </Flex>

          <Flex width={{ d: 420 }} ml={{ d: 60 }} flexShrink={0} />
        </Section>
      </Flex>
      <Flex py={{ m: 30, t: 60, d: 90 }} bg="gray_200">
        <Section flex={1} flexDirection={{ m: 'column', d: 'row' }} flexWrap="wrap">
          <SearchWrapper>
            <Flex alignItems="center" flexDirection="row">
              <Flex mx={1} flexGrow={0}>
                <MessageIcon
                  label="Enviar"
                  labelSize={8}
                  icon="email"
                  size="large"
                  color={tab === 'new' ? 'white' : 'black'}
                  colorHover="white"
                  colorClick="white"
                  bg={tab === 'new' ? 'primary_400' : 'transparent'}
                  bgHover="primary_200"
                  bgClick="primary_600"
                  flexShrink={0}
                  width={64}
                  height={64}
                  iconWidth={32}
                  justifyContent="center"
                  cursor="pointer"
                  borderRadius={4}
                  onClick={() => setTab('new')}
                />
              </Flex>
              <Flex mx={1} flexGrow={0}>
                <MessageIcon
                  label="Todas"
                  labelSize={8}
                  icon="inbox"
                  size="large"
                  color={tab === 'all' ? 'white' : 'black'}
                  colorHover="white"
                  colorClick="white"
                  bg={tab === 'all' ? 'primary_400' : 'transparent'}
                  bgHover="primary_200"
                  bgClick="primary_600"
                  flexShrink={0}
                  width={64}
                  height={64}
                  iconWidth={32}
                  justifyContent="center"
                  cursor="pointer"
                  borderRadius={4}
                  onClick={() => setTab('all')}
                />
              </Flex>
              <Flex mx={1} flexGrow={0}>
                <MessageIcon
                  label="Arquivadas"
                  labelSize={8}
                  icon="archive"
                  size="large"
                  color={tab === 'archives' ? 'white' : 'black'}
                  colorHover="white"
                  colorClick="white"
                  bg={tab === 'archives' ? 'primary_400' : 'transparent'}
                  bgHover="primary_200"
                  bgClick="primary_600"
                  flexShrink={0}
                  width={64}
                  height={64}
                  iconWidth={32}
                  justifyContent="center"
                  cursor="pointer"
                  borderRadius={4}
                  onClick={() => setTab('archives')}
                />
              </Flex>
              <Flex mx={1} flexGrow={0}>
                <MessageIcon
                  label="Enviadas"
                  labelSize={8}
                  icon="arrowRightTop"
                  size="large"
                  color={tab === 'sent' ? 'white' : 'black'}
                  colorHover="white"
                  colorClick="white"
                  bg={tab === 'sent' ? 'primary_400' : 'transparent'}
                  bgHover="primary_200"
                  bgClick="primary_600"
                  flexShrink={0}
                  width={64}
                  height={64}
                  iconWidth={32}
                  justifyContent="center"
                  cursor="pointer"
                  borderRadius={4}
                  onClick={() => setTab('sent')}
                />
              </Flex>
              <Flex mx={1} flexGrow={0}>
                <MessageIcon
                  label="Deletadas"
                  labelSize={8}
                  icon="trash"
                  size="large"
                  color={tab === 'deleted' ? 'white' : 'black'}
                  colorHover="white"
                  colorClick="white"
                  bg={tab === 'deleted' ? 'primary_400' : 'transparent'}
                  bgHover="primary_200"
                  bgClick="primary_600"
                  flexShrink={0}
                  width={64}
                  height={64}
                  iconWidth={32}
                  justifyContent="center"
                  cursor="pointer"
                  borderRadius={4}
                  onClick={() => setTab('deleted')}
                />
              </Flex>
            </Flex>
            <SearchBar
              searchText={searchText}
              onSearchTextChange={setSearchText}
              totalPages={totalPages}
              onSearchSubmit={onSearchSubmit}
              currentPage={currentPage}
              selectedRows={false}
              actions={[]}
              filters={[
                {
                  selectedValue: enabledFilter,
                  onChange: (changedEnabledFilter) => setEnabledFilter(Number(changedEnabledFilter)),
                  options: [
                    { value: 0, label: 'Todos' },
                    { value: 1, label: 'Lidos' },
                    { value: 2, label: 'Não Lidos' },
                  ],
                  minWidth: 200,
                },
              ]}
            />
          </SearchWrapper>
          <Flex mt={4} height={50}>
            <Flex bg="black" alignItems="center" width={400} py={16} pl={6} pr={2} flexGrow={0}>
              <Flex>
                <Checkbox
                  color="gray_500"
                  // checked={sanitizedClassEvolution?.length === Object.keys(selectedStudents).length}
                  // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  //   if (event.target.checked) {
                  //     selectManyStudents(true);
                  //   } else {
                  //     selectManyStudents(false);
                  //   }
                  // }}
                />
                <Typography color="gray_500" upper ml={2}>
                  Mensagens
                </Typography>
              </Flex>
              <Flex flexGrow={0}>
                <IconPrimary icon="swap" />
              </Flex>
            </Flex>
            <Flex bg="black" ml="2px" alignItems="center" p={12} pl={6}>
              <Flex alignItems="center" flexGrow={0}>
                <Icon icon="archive" />
                <Typography type="type1" color="gray_500" ml={2} fontWeight="bold">
                  Arquivar
                </Typography>
              </Flex>
              <Flex ml={4} alignItems="center" flexGrow={0}>
                <Icon icon="trash" />
                <Typography type="type1" color="gray_500" ml={2} fontWeight="bold">
                  Deletar
                </Typography>
              </Flex>
            </Flex>
          </Flex>

          <Flex bg="white" flexWrap="nowrap" minHeight={500}>
            <Flex flexDirection="column" width={400} height={90} flexGrow={0}>
              {tab === 'new'
                ? messages
                    .filter((item) => item.type === 'sent')
                    .map((item, index) => {
                      return (
                        <MessageCard message={item} onClickCard={() => setMessageSelected(item.uuid)} selected={messageSelected === item.uuid} />
                      );
                    })
                : messages
                    .filter((item) => item.type === tab)
                    .map((item, index) => {
                      return (
                        <MessageCard message={item} onClickCard={() => setMessageSelected(item.uuid)} selected={messageSelected === item.uuid} />
                      );
                    })}
            </Flex>
            <Flex flexDirection="column" borderLeftStyle="solid" borderLeftWidth="2px" borderLeftColor="gray_100">
              {messageSelected !== null || tab === 'new' ? (
                <MessageInbox
                  message={messages.find((element: MessageItemProps) => element.uuid === messageSelected)}
                  tab={tab}
                  onSentMessage={(newMessage: MessageItemProps) => {
                    setMessages((prevMessages) => [...prevMessages, newMessage]);
                    setTab('sent');
                  }}
                  onSentMessageAnswer={(newAnswer: answerItem, uuid: string) => {
                    setMessages((prevAnswer) => prevAnswer.map((item) => (item.uuid === uuid ? { ...item, answer: newAnswer } : item)));
                  }}
                />
              ) : (
                <Flex alignItems="center" justifyContent="center" flexDirection="column">
                  <IconMessagePrimary icon="emailOpen" />
                  <Typography type="type3" color="gray_500">
                    Selecione uma mensagem para ler
                  </Typography>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Section>
      </Flex>
    </Page>
  );
};

export default MessagesView;
